<template>
  <div>
    <v-row>
      <v-col>
        <h2 v-if="$route.params.id != undefined">{{ $t('media_coverage.edit_media_coverage') }}</h2>
        <h2 v-else>{{ $t('media_coverage.new_media_coverage') }}</h2>
      </v-col>
    </v-row>
    <v-row class="mt-8">
      <v-col xl="6" lg="6" md="6" sm="6" cols="12">
        <v-select
          :items="category_list"
          item-text="item-text"
          item-value="item-value"
          :label="$t('media_coverage.category')"
          v-model="media_coverage_data.category"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col xl="6" lg="6" md="6" sm="6" cols="12">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="media_coverage_date" persistent width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="media_coverage_date"
              :label="$t('media_coverage.publish_date')"
              :prepend-icon="calendar_icon"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="media_coverage_date" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modal = false"> {{ $t('general.cancel') }} </v-btn>
            <v-btn text color="primary" @click="$refs.dialog.save(media_coverage_date)"> {{ $t('general.ok') }} </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
    </v-row>
    <MediaCoverageTab
      v-on:getTitle="getTitle"
      v-on:getContent="getContent"
      v-on:getImage="getImage"
      :title="media_coverage_data.title"
      :content="media_coverage_data.content"
      :image="media_coverage_data.upload_image"
    />
    <v-row class="mt-8">
      <v-col>
        <v-btn
          v-if="$route.params.id != undefined"
          color="success"
          depressed
          @click="updateMediaCoverage"
          :loading="loading"
        >
          {{ $t('general.save') }}
        </v-btn>
        <v-btn v-else color="success" depressed @click="addNewMediaCoverage" :loading="loading">
          {{ $t('general.add') }}
        </v-btn>
      </v-col>
    </v-row>
    <SnackBar :text="snack_bar_text" :snackbar="snack_bar_open" v-on:close="updateSnackBar" />
  </div>
</template>

<script>
import { mdiCamera, mdiCalendar } from '@mdi/js'
import { getData, postData } from '@/api'
import { MEDIA_PATH, DEFAULT_IMAGE_PATH } from '@/global'
import SnackBar from '@/components/SnackBar'
import Dialog from '@/components/Dialog'
import { globalFunc } from '@/global'
import MediaCoverageTab from '@/components/MediaCoverageTab'

export default {
  name: 'MediaCoverageDetail',
  mixins: [globalFunc, MEDIA_PATH, DEFAULT_IMAGE_PATH],
  components: { SnackBar, Dialog, MediaCoverageTab },
  data: () => ({
    camera_icon: mdiCamera,
    calendar_icon: mdiCalendar,
    media_coverage_data: {
      publish_date: '',
      upload_image: {
        zh: '',
        en: '',
        cn: '',
      },
      category: '',
      title: {
        zh: '',
        en: '',
        cn: '',
      },
      content: {
        zh: '',
        en: '',
        cn: '',
      },
    },
    category_list: [],
    modal: false,
    img_path: DEFAULT_IMAGE_PATH,
    media_coverage_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substring(0, 10),
    snack_bar_text: '',
    snack_bar_open: false,
    loading: false,
  }),
  methods: {
    async uploadImage(file) {
      if (file == null) {
        this.removeImage()
        return
      }

      try {
        let base64Path = await globalFunc.firstFileToBase64(file)

        let type = file.type.substring(file.type.lastIndexOf('/') + 1)

        let params = new URLSearchParams()
        params.set(
          'upload_file',
          JSON.stringify({
            upload_data: base64Path,
            upload_file_type: type,
          }),
        )

        let upload_file = await postData(params)

        file = null
        this.media_coverage_data.upload_image = upload_file
        this.img_path = MEDIA_PATH + upload_file
        this.snack_bar_text = this.$t('instruction.upload_success')
        this.snack_bar_open = true
      } catch (error) {
        globalFunc.log(error)
        file = null
        this.media_coverage_data.upload_image = ''
        this.img_path = DEFAULT_IMAGE_PATH
        this.snack_bar_text = this.$t('instruction.upload_fail')
        this.snack_bar_open = true
      }
    },
    removeImage() {
      this.img_path = DEFAULT_IMAGE_PATH
      this.media_coverage_data.upload_image = ''
      this.$refs.fileupload.value = null
    },
    getTitle(title, type) {
      this.media_coverage_data.title[type] = title
    },
    getContent(content, type) {
      this.media_coverage_data.content[type] = content
    },
    getImage(image, type) {
      this.media_coverage_data.upload_image[type] = image
    },
    async initializeMediaCoverage() {
      if (!this.loading) {
        this.loading = true

        let error = true
        try {
          let params = new URLSearchParams()

          params.set(
            'get_single_data_by_data_type_and_id',
            JSON.stringify({
              id: this.$route.params.id,
              data_type: 'news_data',
            }),
          )

          let result = await getData(params)
          if (globalFunc.DataValid(result)) {
            this.media_coverage_date = result.publish_date

            Object.assign(this.media_coverage_data, result)
            error = false
          }
        } catch (error) {
          globalFunc.log(error)
        }

        if (error) {
          this.snack_bar_text = this.$t('instruction.data_not_found')
          this.snack_bar_open = true

          setTimeout(() => {
            this.$router.push({ name: 'MediaCoverage' })
          }, 2000)
        } else {
          this.loading = false
        }
      }
    },
    async addNewMediaCoverage() {
      if (!this.loading) {
        this.loading = true
        this.media_coverage_data.publish_date = this.media_coverage_date

        if (!globalFunc.DataValid(this.media_coverage_data.title.zh)) {
          this.snack_bar_text =
            this.$t('error.force_input') + ' ' + this.$t('general.zh') + ' ' + this.$t('general.title')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (!globalFunc.DataValid(this.media_coverage_data.content.zh)) {
          this.snack_bar_text =
            this.$t('error.force_input') + ' ' + this.$t('general.zh') + ' ' + this.$t('general.content')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        try {
          let params = new URLSearchParams()

          params.set('add_news', JSON.stringify(this.media_coverage_data))

          let result = await postData(params)
          globalFunc.log(result)

          this.snack_bar_text = this.$t('instruction.create_success')
          this.snack_bar_open = true

          setTimeout(() => {
            this.$router.push({ name: 'MediaCoverage' })
          }, 2000)
        } catch (error) {
          this.snack_bar_text = this.$t('instruction.create_fail')
          this.snack_bar_open = true
          this.loading = false
          globalFunc.log(error)
        }
      }
    },
    async updateMediaCoverage() {
      if (!this.loading) {
        this.loading = true
        this.media_coverage_data.publish_date = this.media_coverage_date

        if (!globalFunc.DataValid(this.media_coverage_data.title.zh)) {
          this.snack_bar_text =
            this.$t('error.force_input') + ' ' + this.$t('general.zh') + ' ' + this.$t('general.title')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (!globalFunc.DataValid(this.media_coverage_data.content.zh)) {
          this.snack_bar_text =
            this.$t('error.force_input') + ' ' + this.$t('general.zh') + ' ' + this.$t('general.content')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        try {
          let params = new URLSearchParams()

          params.set('update_news', JSON.stringify(this.media_coverage_data))

          let result = await postData(params)
          globalFunc.log(result)

          this.snack_bar_text = this.$t('instruction.update_success')
          this.snack_bar_open = true

          setTimeout(() => {
            this.$router.push({ name: 'MediaCoverage' })
          }, 2000)
        } catch (error) {
          this.snack_bar_text = this.$t('instruction.update_fail')
          this.snack_bar_open = true
          this.loading = false
          globalFunc.log(error)
        }
      }
    },
    initializeCategory() {
      this.category_list = [
        { 'item-text': this.$t('media_coverage.consumer_electronics'), 'item-value': 'Consumer Electronics' },
        { 'item-text': this.$t('media_coverage.automotive_electronics'), 'item-value': 'Automotive Electronics' },
        { 'item-text': this.$t('media_coverage.data_centers'), 'item-value': 'Data Centers' },
        { 'item-text': this.$t('media_coverage.renewable_energy'), 'item-value': 'Renewable Energy' },
        { 'item-text': this.$t('media_coverage.industrial'), 'item-value': 'Industrial' },
      ]
    },
    updateSnackBar(status) {
      this.snack_bar_open = status
    },
  },
  created() {
    this.initializeCategory()
    if (this.$route.params.id != undefined) {
      this.initializeMediaCoverage()
    }
  },
}
</script>
